"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _invariant = _interopRequireDefault(require("invariant"));

var _fp = _interopRequireDefault(require("lodash/fp"));

/**
 * Currying funtaion that return
 *
 * @function
 *
 * @param {Object} [options]
 * @param {string} [options.amountField = 'amount'] Name of object field with amout.
 * @param {string} [options.currencyField = 'currency'] Name of object field with amout.
 * @param {TDefault} [options.defaultValue = false] Value returned if amout is not defined.
 * @param {string} currency
 * @param {Array<Object>} price
 *
 * @return {number | TDefault} Amount or `defaultValue`.
 */
var priceFromMultiprice = _fp.default.curry(function (options, currency, price) {
  var _ref = options || {},
      _ref$amountField = _ref.amountField,
      amountField = _ref$amountField === void 0 ? 'amount' : _ref$amountField,
      _ref$currencyField = _ref.currencyField,
      currencyField = _ref$currencyField === void 0 ? 'currency' : _ref$currencyField,
      _ref$defaultValue = _ref.defaultValue,
      defaultValue = _ref$defaultValue === void 0 ? false : _ref$defaultValue;

  (0, _invariant.default)(currency && _fp.default.isString(currency), 'priceFromMultiprice() requires `currency` to be an non empty string.');
  (0, _invariant.default)(Array.isArray(price), 'priceFromMultiprice() requires `price` to be an `Array<Object>`.');
  return (price.find(function (p) {
    return p[currencyField || 'currency'] === currency;
  }) || {})[amountField || 'amount'] || defaultValue;
});

var _default = priceFromMultiprice;
exports.default = _default;